module.exports = __webpack_public_path__ + "img/purchase.0a25d6ce.svg";